import Text from './Text';
import LinearGradientText from './LinearGradientText';

export default Text;
export {Text, LinearGradientText};
